import { render, staticRenderFns } from "./TestTablePage.vue?vue&type=template&id=3dfe59e1&"
import script from "./TestTablePage.vue?vue&type=script&lang=js&"
export * from "./TestTablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports